/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */

/**
 * Replace a single parameter from a URL string given like
 * myUrl/:parameterToReplace/restOfUrlToIgnore
 * https://reactrouter.com/docs/en/v6/getting-started/concepts#route-matches
 *
 * @param {String} url The url containing params preceded by a colon.
 * @param {Object} paramsToReplace The map of params to replace.
 * @returns {String} The final url, with the parameter placeholders replaced.
 */
const replaceUrlParams = (
  url: string = "",
  paramsToReplace: Record<string, string | null> = {}
) => {
  const paramsArrayWithColon = Object.entries(paramsToReplace).map(
    ([key, value]) => {
      return { [`:${key}`]: value };
    }
  );
  const paramsWithColon = Object.assign({}, ...paramsArrayWithColon);

  const re = new RegExp(Object.keys(paramsWithColon).join("|"), "gi");

  return url.replace(re, function (matched) {
    return paramsWithColon[matched];
  });
};

export default replaceUrlParams;
